<template>
  <v-layout
    wrap
  >
    <v-flex
      xs12
      md5
      pt-6
    >
      <v-select
        v-model="selectedStrategy"
        :items="userProjects"
        :item-text="'name'"
        :return-object="true"
        :label="$t('projects.chooseStrategy')"
        dense
      />
    </v-flex>
    <v-flex
      md2
      xs6
    >
      <v-menu
        v-model="PickerFrom"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="fromDate"
            :label="$t('globals.from')"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker 
          v-model="params.fromDate" 
          :locale="$i18n.locale"
          min="2021-11-01"
          :max="params.toDate || $moment().format('YYYY-MM-DD')"
          @input="PickerFrom = false"
        />
      </v-menu>
    </v-flex>
    <v-flex
      md2
      xs6
    >
      <v-menu
        v-model="PickerTo"
        :close-on-content-click="false"
        :nudge-right="40"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="toDate"
            :label="$t('globals.to')"
            prepend-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker 
          v-model="params.toDate" 
          :locale="$i18n.locale"
          :min="params.fromDate || '2021-11-01'"
          :max="$moment().format('YYYY-MM-DD')"
          @input="PickerTo = false"
        />
      </v-menu>
    </v-flex>
    <v-flex
      xs12
      md3
      pt-7
    >
      <v-btn
        outlined
        text
        small
        :disabled="$apollo.loading || !selectedStrategy"
        @click="reload()"
      >
        {{ $t('globals.loadStatsButton') }}
      </v-btn>
    </v-flex>
    <v-flex
      v-if="investorStatsByProject"
      xs12
    >
      <v-simple-table class="result-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left" />
              <th class="text-left">
                {{ $t('traderdashboard.strategy') }}
              </th>
              <th class="text-left">
                {{ $t('traderdashboard.pnl') }}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('traderdashboard.pnlHint') }}
                </v-tooltip>
              </th>
              <th class="text-left">
                {{ $t('traderdashboard.feePaid') }}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('traderdashboard.feePaidHint') }}
                </v-tooltip>
              </th>
              <th class="text-left">
                {{ $t('traderdashboard.linkedAccounts') }}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t('traderdashboard.linkedHint') }}
                </v-tooltip>
              </th>
            </tr>
          </thead>
          <tbody class="text-no-wrap">
            <tr>
              <td>
                <v-avatar
                  :tile="false"
                  :size="40"
                >
                  <v-img
                    :src="(selectedStrategy.logo || require('@/images/no-image.png'))"
                    :lazy-src="selectedStrategy.logo"
                    max-height="40"
                    contain
                  />
                </v-avatar>  
              </td>
              <td><b class="ticker">{{ selectedStrategy.ticker }}</b><br> <small class="name">{{ selectedStrategy.name }}</small></td>
              <td>{{ investorStatsByProject.fee_currency | renderSymbol }} {{ investorStatsByProject.pnl }}</td>
              <td>{{ investorStatsByProject.fee_currency| renderSymbol }} {{ investorStatsByProject.fee_paid }}</td>
              <td>{{ investorStatsByProject.linked_investors }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-flex>
  </v-layout>
</template>

<script>

import USER_PROJECTS_QUERY from '@/graphql/queries/UserProjects.gql'
import PROJECTS_STATS_QUERY from '@/graphql/queries/InvestorStatsByProject.gql'

export default {
  name: 'StrategyStats',
  props: {
    whitelabelUuid: {
      type: String,
      default: null
    },
  },
 data() {
    return {
      PickerFrom: null,
      PickerTo: null,
      loading: false,
      params: {
        fromDate: this.$moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        toDate: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        id: null
      },
      selectedStrategy: null,
    }
  },
  computed: {
    fromDate() {
      return this.$moment(this.params.fromDate).startOf('day').format('ll');
    },
    toDate() {
      return this.$moment(this.params.toDate).endOf('day').format('ll');
    }
  },
  methods: {
    reload() {
      this.params.fromDate = this.$moment(this.params.fromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.params.toDate = this.$moment(this.params.toDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.params.id = this.selectedStrategy.id
      this.$apollo.queries.investorStatsByProject.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    userProjects: {
      query: USER_PROJECTS_QUERY,
      variables() {
        return {
          whitelabel_uuid: this.whitelabelUuid
        }
      },
      skip() {
        return !this.whitelabelUuid
      }
    },
    investorStatsByProject: {
      query: PROJECTS_STATS_QUERY,
      variables() {
        return this.params
      },
      skip() {
        return !this.params.id
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .result-table {
    .v-icon {
      font-size:15px;
    }
  }
  .ticker {
    font-weight: 700;
    color: #9c27b0;
  }
  .name {
    font-weight: 600;
    color: #7f97ab;
  }
  .v-avatar {
    margin: 10px 0;
  }
</style>